<script lang="ts">
  import { _ } from 'svelte-i18n';
  import Header from '$lib/components/sections/Header.svelte';
  import Footer from '$lib/components/sections/Footer.svelte';

  const p = 'pages.faqPage.sections';

  const sections = $derived([
    {
      id: 'getting-started',
      title: $_('pages.faqPage.sections.gettingStarted.title'),
      questions: [
        { q: $_(`${p}.gettingStarted.q1.q`), a: $_(`${p}.gettingStarted.q1.a`) },
        { q: $_(`${p}.gettingStarted.q2.q`), a: $_(`${p}.gettingStarted.q2.a`) },
        { q: $_(`${p}.gettingStarted.q3.q`), a: $_(`${p}.gettingStarted.q3.a`) },
        { q: $_(`${p}.gettingStarted.q4.q`), a: $_(`${p}.gettingStarted.q4.a`) }
      ]
    },
    {
      id: 'time-tracking',
      title: $_(`${p}.timeTracking.title`),
      questions: [
        { q: $_(`${p}.timeTracking.q1.q`), a: $_(`${p}.timeTracking.q1.a`) },
        { q: $_(`${p}.timeTracking.q2.q`), a: $_(`${p}.timeTracking.q2.a`) },
        { q: $_(`${p}.timeTracking.q3.q`), a: $_(`${p}.timeTracking.q3.a`) },
        { q: $_(`${p}.timeTracking.q4.q`), a: $_(`${p}.timeTracking.q4.a`) }
      ]
    },
    {
      id: 'tasks-todos-notes',
      title: $_(`${p}.tasksTodosNotes.title`),
      questions: [
        { q: $_(`${p}.tasksTodosNotes.q1.q`), a: $_(`${p}.tasksTodosNotes.q1.a`) },
        { q: $_(`${p}.tasksTodosNotes.q2.q`), a: $_(`${p}.tasksTodosNotes.q2.a`) },
        { q: $_(`${p}.tasksTodosNotes.q3.q`), a: $_(`${p}.tasksTodosNotes.q3.a`) },
        { q: $_(`${p}.tasksTodosNotes.q4.q`), a: $_(`${p}.tasksTodosNotes.q4.a`) }
      ]
    },
    {
      id: 'clients-reporting',
      title: $_(`${p}.clientsReporting.title`),
      questions: [
        { q: $_(`${p}.clientsReporting.q1.q`), a: $_(`${p}.clientsReporting.q1.a`) },
        { q: $_(`${p}.clientsReporting.q2.q`), a: $_(`${p}.clientsReporting.q2.a`) },
        { q: $_(`${p}.clientsReporting.q3.q`), a: $_(`${p}.clientsReporting.q3.a`) },
        { q: $_(`${p}.clientsReporting.q4.q`), a: $_(`${p}.clientsReporting.q4.a`) }
      ]
    },
    {
      id: 'team',
      title: $_(`${p}.team.title`),
      questions: [
        { q: $_(`${p}.team.q1.q`), a: $_(`${p}.team.q1.a`) },
        { q: $_(`${p}.team.q2.q`), a: $_(`${p}.team.q2.a`) },
        { q: $_(`${p}.team.q3.q`), a: $_(`${p}.team.q3.a`) }
      ]
    },
    {
      id: 'communication',
      title: $_(`${p}.communication.title`),
      questions: [
        { q: $_(`${p}.communication.q1.q`), a: $_(`${p}.communication.q1.a`) },
        { q: $_(`${p}.communication.q2.q`), a: $_(`${p}.communication.q2.a`) },
        { q: $_(`${p}.communication.q3.q`), a: $_(`${p}.communication.q3.a`) }
      ]
    },
    {
      id: 'integrations',
      title: $_(`${p}.integrations.title`),
      questions: [
        { q: $_(`${p}.integrations.q1.q`), a: $_(`${p}.integrations.q1.a`) },
        { q: $_(`${p}.integrations.q2.q`), a: $_(`${p}.integrations.q2.a`) },
        { q: $_(`${p}.integrations.q3.q`), a: $_(`${p}.integrations.q3.a`) }
      ]
    },
    {
      id: 'billing-plans',
      title: $_(`${p}.billingPlans.title`),
      questions: [
        { q: $_(`${p}.billingPlans.q1.q`), a: $_(`${p}.billingPlans.q1.a`) },
        { q: $_(`${p}.billingPlans.q2.q`), a: $_(`${p}.billingPlans.q2.a`) },
        { q: $_(`${p}.billingPlans.q3.q`), a: $_(`${p}.billingPlans.q3.a`) },
        { q: $_(`${p}.billingPlans.q4.q`), a: $_(`${p}.billingPlans.q4.a`) }
      ]
    },
    {
      id: 'privacy-security',
      title: $_(`${p}.privacySecurity.title`),
      questions: [
        { q: $_(`${p}.privacySecurity.q1.q`), a: $_(`${p}.privacySecurity.q1.a`) },
        { q: $_(`${p}.privacySecurity.q2.q`), a: $_(`${p}.privacySecurity.q2.a`) },
        { q: $_(`${p}.privacySecurity.q3.q`), a: $_(`${p}.privacySecurity.q3.a`) }
      ]
    }
  ]);
</script>

<svelte:head>
  <title>{$_('pages.faqPage.meta.title')}</title>
  <meta name="description" content={$_('pages.faqPage.meta.description')} />
	<meta property="og:title" content="{$_('pages.faqPage.meta.title')}" />
	<meta property="og:description" content={$_('pages.faqPage.meta.description')} />
  <link rel="canonical" href="https://heyweek.com/faq" />
</svelte:head>

<Header />

<main class="page">

  <!-- Hero -->
  <section class="hero">
    <div class="container">
      <p class="hero__eyebrow">{$_('pages.faqPage.hero.eyebrow')}</p>
      <h1 class="hero__title">{$_('pages.faqPage.hero.title')}</h1>
      <p class="hero__subtitle">{$_('pages.faqPage.hero.subtitleBefore')} <a href="/contact">{$_('pages.faqPage.hero.subtitleLink')}</a> {$_('pages.faqPage.hero.subtitleAfter')}</p>
    </div>
  </section>

  <div class="layout">
    <div class="container--wide">

      <!-- Sidebar nav -->
      <nav class="nav" aria-label="FAQ sections">
        {#each sections as section}
          <a href="#{section.id}" class="nav__link">{section.title}</a>
        {/each}
      </nav>

      <!-- Questions -->
      <div class="content">
        {#each sections as section}
          <section class="section" id={section.id}>
            <h2 class="section__title">{section.title}</h2>
            <div class="qa-list">
              {#each section.questions as item}
                <div class="qa">
                  <h3 class="qa__q">{item.q}</h3>
                  <p class="qa__a">{item.a}</p>
                </div>
              {/each}
            </div>
          </section>
        {/each}

        <!-- Still stuck -->
        <div class="still-stuck">
          <h2 class="still-stuck__title">{$_('pages.faqPage.stillStuck.title')}</h2>
          <p class="still-stuck__body">{$_('pages.faqPage.stillStuck.body')}</p>
          <a href="/contact" class="still-stuck__link">
            {$_('pages.faqPage.stillStuck.link')}
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <line x1="5" y1="12" x2="19" y2="12"/>
              <polyline points="12 5 19 12 12 19"/>
            </svg>
          </a>
        </div>

      </div>
    </div>
  </div>

</main>

<Footer />

<style>
  .page {
    min-height: 100vh;
  }

  .container {
    max-width: 760px;
    margin-inline: auto;
    padding-inline: var(--container-padding, 1.5rem);
  }

  .container--wide {
    max-width: 1000px;
    margin-inline: auto;
    padding-inline: var(--container-padding, 1.5rem);
    display: grid;
    grid-template-columns: 180px 1fr;
    gap: var(--space-16);
    align-items: start;
  }

  /* ── Hero ── */
  .hero {
    padding-block: var(--space-20) var(--space-16);
    border-bottom: 1px solid var(--border-light);
  }

  .hero__eyebrow {
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-medium);
    color: var(--text-secondary);
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin-bottom: var(--space-5);
  }

  .hero__title {
    font-size: clamp(3rem, 7vw, 5rem);
    font-weight: var(--font-weight-bold);
    line-height: 1.05;
    letter-spacing: -0.03em;
    color: var(--text-primary);
    margin-bottom: var(--space-4);
  }

  .hero__subtitle {
    font-size: var(--font-size-lg);
    color: var(--text-secondary);
    line-height: 1.7;
  }

  .hero__subtitle a {
    color: var(--text-primary);
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  .hero__subtitle a:hover {
    color: var(--text-brand);
  }

  /* ── Layout ── */
  .layout {
    padding-block: var(--space-16) var(--space-20);
  }

  /* ── Sidebar nav ── */
  .nav {
    position: sticky;
    top: var(--space-10);
    display: flex;
    flex-direction: column;
    gap: var(--space-1);
  }

  .nav__link {
    font-size: var(--font-size-sm);
    color: var(--text-secondary);
    text-decoration: none;
    padding-block: var(--space-1);
    line-height: 1.5;
    transition: color 0.15s ease;
  }

  .nav__link:hover {
    color: var(--text-primary);
  }

  /* ── Content ── */
  .content {
    min-width: 0;
  }

  .section {
    margin-bottom: var(--space-16);
    padding-top: var(--space-2);
  }

  .section__title {
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-semibold);
    color: var(--text-secondary);
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: var(--space-8);
    padding-bottom: var(--space-4);
    border-bottom: 1px solid var(--border-light);
  }

  /* ── Q&A ── */
  .qa-list {
    display: flex;
    flex-direction: column;
    gap: var(--space-10);
  }

  .qa__q {
    font-size: var(--font-size-base);
    font-weight: var(--font-weight-semibold);
    color: var(--text-primary);
    letter-spacing: -0.01em;
    margin-bottom: var(--space-3);
    line-height: 1.4;
  }

  .qa__a {
    font-size: var(--font-size-base);
    color: var(--text-secondary);
    line-height: 1.8;
    hyphens: none;
  }

  /* ── Still stuck ── */
  .still-stuck {
    margin-top: var(--space-16);
    padding-top: var(--space-10);
    border-top: 1px solid var(--border-light);
  }

  .still-stuck__title {
    font-size: var(--font-size-lg);
    font-weight: var(--font-weight-semibold);
    color: var(--text-primary);
    letter-spacing: -0.02em;
    margin-bottom: var(--space-2);
  }

  .still-stuck__body {
    font-size: var(--font-size-base);
    color: var(--text-secondary);
    line-height: 1.7;
    margin-bottom: var(--space-5);
  }

  .still-stuck__link {
    display: inline-flex;
    align-items: center;
    gap: var(--space-2);
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-semibold);
    color: var(--text-primary);
    text-decoration: none;
  }

  .still-stuck__link:hover {
    color: var(--text-brand);
  }

  /* ── Responsive ── */
  @media (max-width: 768px) {
    .container--wide {
      grid-template-columns: 1fr;
      gap: var(--space-8);
    }

    .nav {
      position: static;
      flex-direction: row;
      flex-wrap: wrap;
      gap: var(--space-2) var(--space-5);
      padding-bottom: var(--space-6);
      border-bottom: 1px solid var(--border-light);
    }
  }
</style>
